const counterData = 12;

export default counterData;
